import { curry, find, map, propEq } from 'ramda'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const getRelation = curry((relationList, uuid) => {
  const result = find(propEq(uuid, `uuid`))(relationList)
  if (!result) {
    throw new Error(`No relation with UUID: '${uuid}'`)
  }

  return result
})

export const mapRelations = curry((relationList, list) =>
  map(getRelation(relationList), list)
)
